<template>
    <div class="type_tube_container">
        <div class="type_tube_box" v-if="hasAccess('248')">
            <SearchModular :modular="'type'" :add_name="add_name" @open_dialogVisible="open_dialogVisible" @batch_del_click="batch_del_click" @get_type_list="get_type_list"/>
            <CommonTable :modular="'type'" :table_title_list="table_title_list" @open_dialogVisible="open_dialogVisible" :tableData="type_list" @single_del="single_del"/>
            <PaginationModular @set_page="set_page" @set_limit="set_limit" 
            :data_obj="type_obj" :page="page" :limit="limit"
            />
        </div>
        <div class="dialog_container">
            <el-dialog
                title="输入类型名称"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
                <div class="dialog_box">
                    <div class="top_box">
                        <div class="input_box">
                            <span><i>*</i> 类型名称:</span>
                            <input type="text" v-model="type_name" placeholder="请输入">
                        </div>
                        <div class="doc">
                            *最多四个字符
                        </div>
                    </div>
                    <div class="bottom_box">
                        <div class="input_box">
                            <span><i>*</i> 权重值:</span>
                            <input type="text" v-model="sort_weight" placeholder="请输入">
                        </div>
                        <div class="doc">权重值相同，按最新编辑时间排序在前</div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="determine">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { hasAccess } from '@/common/utils'
    import { mapState, mapGetters, mapActions } from "vuex";
    import SearchModular from '../../components/search_modular/search_modular.vue'
    import CommonTable from '../../components/common_table/common_table.vue'
    import PaginationModular from '../../components/pagination_modular/pagination_modular.vue'
	export default {
        components:{
            SearchModular,
            CommonTable,
            PaginationModular
        },
        data(){
            return{
                hasAccess,
                table_title_list:[
                    {prop:'name',label:'类型名称'},
                    {prop:'source_number',label:'资源数量'},
                    {prop:'sort_weight',label:'权重值'}
                ],
                add_name:'新增类型',
                dialogVisible:false,
                tableData: [],
                type_name:'',
                sort_weight:'',
                id:'',
                isCreate:false
            }
        },
        watch: {
            type_name (newValue, oldValue) { // 监听电话号码
                if(this.type_name){
                    if(this.type_name.length>4){
                        this.type_name = this.type_name.slice(0,this.type_name.length-1)
                    }
                }
            }
        },
        computed:{
            ...mapGetters("type_tube_vuex",['type_list','type_obj','ids','page','limit'])
        },
        mounted(){
            this.get_type_list()
        },
        methods:{
            ...mapActions("type_tube_vuex",['get_type_list']),
            set_limit(val){
                this.$store.commit("type_tube_vuex/set_limit",val)
            },
            set_page(val){
                this.$store.commit("type_tube_vuex/set_page",val)
                this.get_type_list()
            },
            single_del(val){
                let _this = this
                _this.$store.dispatch('type_tube_vuex/del_type', {
                    data:{
                        ids:val.id,
                    },
                    scCallback(res,type) {
                        _this.get_type_list()
                    },
                    afterCallback(err) {
                    }
                })
            },
            //批量删除
            batch_del_click(){
                let _this = this
                _this.$store.dispatch('type_tube_vuex/del_type', {
                    data:{
                        ids:this.ids,
                    },
                    scCallback(res,type) {
                        _this.get_type_list()
                    },
                    afterCallback(err) {
                    }
                })
            },
            handleClose(){
                this.dialogVisible = false
            },
            open_dialogVisible(data){
                if(data){
                    this.isCreate = false
                    this.id = data.id
                    this.type_name = data.name
                    this.sort_weight = data.sort_weight
                }else{
                    this.isCreate = true
                }
                this.dialogVisible = true
            },
            //点击确定
            determine(){
                if(!this.type_name){
                    this.$message({
                        message:'请输入类型名称',offset: 90,type: 'error'
                    });
                    return
                }
                if(!this.sort_weight){
                    this.$message({
                        message:'请输入权重值',offset: 90,type: 'error'
                    });
                    return
                }

                if(this.isCreate){
                    this.add_type()
                }else{
                    this.edit_type()
                }

                this.dialogVisible = false
            },
            edit_type(){
                let _this = this
                _this.$store.dispatch('type_tube_vuex/edit_type', {
                    data:{
                        id:this.id,
                        name:this.type_name,
                        sort_weight:this.sort_weight
                    },
                    scCallback(res,type) {
                        _this.get_type_list()
                        _this.type_name = ''
                        _this.sort_weight = ''
                    },
                    afterCallback(err) {
                    }
                })
            },
            //添加类型 + 编辑类型
            add_type(){
                let _this = this
                _this.$store.dispatch('type_tube_vuex/add_type', {
                    data:{
                        name:this.type_name,
                        sort_weight:this.sort_weight
                    },
                    scCallback(res,type) {
                        _this.get_type_list()
                        _this.type_name = ''
                        _this.sort_weight = ''
                    },
                    afterCallback(err) {
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.type_tube_container{
    background: #f5f5f5;
    padding: 20px;
    .type_tube_box{
        background: #fff;
    }
    .dialog_container{
        .top_box,.bottom_box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .input_box{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 10px 0;
                span{
                    display: flex;
                    min-width: 80px;
                    justify-content: flex-end;
                    padding-right: 10px;
                    i{
                        color: red;
                    }
                }
                input{
                    width: 200px;
                    height: 30px;
                    border: 1px solid #dbd9d9;
                    padding: 0 10px;
                    border-radius: 3px;
                }
            }
        }
        .bottom_box{
            
        }
    }
}
</style>